<template>
<div class="content-wrappper ">
  <div class="services-main">
    <div class="col-md-12 services-header servicesBackground">
        <div class="pb-24  pr-24 d-flex justify-content-between ">
          <span class="m-0 services_check"> {{$t('serviceProviders')}}</span>
            <!-- <button  class="btn btn-todo-list p-0 d-flex" v-if="activeTab==='Labs'" :disabled="!selectedRecords.length" @click="showDetails()"  >
               <img src="/static/images/icons/ic_info.svg"  /><span :title="$t('showContacts')" class="upload-file">{{$t('showContacts')}}</span></button> -->
        </div>
         <div class="col-xs-12 col-md-12 col-sm-12 tabs-main p-0 pr-24">
          <div class="col-xs-12 col-md-12 col-sm-12 main-tabs p-0">
        <div class=" pr-2" @click="showTable('Labs')">
          <div :class="activeTab=='Labs'?'active_progress_bar':''">
          <div class="ul-new-font cursor-pointer pb-11"    :class="activeTab==='Labs'?'active-text':'in-active-text'"> {{$t('Labs')}}</div>
          </div>
        </div>
        <div class=" pl-2 " @click="showTable('certification')">
          <div :class="activeTab=='certification'?'active_progress_bar':''">
          <div class="ul-new-font cursor-pointer pb-11"  :class="activeTab=='certification'?'active-text':'in-active-text'"> {{$t('certificationBodies')}}</div>
          </div>
        </div>
        </div>
      </div>

    <div class="col-xs-12 p-0 ">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
            <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-24">
              <div style="position:relative">
                <search-box  v-model="searchValue" :searchCount="searchCount" @getList="filterServiceProvidersList" :searchPlaceholder="activeTab==='certification'?$t('searchName'):$t('searchLabName')"></search-box>
              </div>
            </div>
        </div>
    </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 pl-24 pr-24 servicesBackground" >
      <div class="regulations" v-if="activeTab==='certification'">
        <table class="table table-responsive registration-data" id="servicesDataList">

            <tr style="background-color: #E6E6E6; !important;">
              <th style="width: 30%;">
                <div class="tableHeader cursor-pointer pl-12" @click="certificatesArrowDirection.name = -(certificatesArrowDirection.name), sortBy('name', certificatesArrowDirection.name)">
                  <div class="ellipsis header-title" :title="$t('name')">{{$t('name')}}</div>
                  <div class="arrow" :class="certificatesArrowDirection.name === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="certificatesArrowDirection.services_offered = -(certificatesArrowDirection.services_offered), sortBy('services_offered', certificatesArrowDirection.services_offered)">
                <div class="ellipsis header-title" :title="$t('servicesOffered')">{{$t('servicesOffered')}}</div>
                  <div class="arrow" :class="certificatesArrowDirection.services_offered === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="certificatesArrowDirection.country = -(certificatesArrowDirection.country), sortBy('country', certificatesArrowDirection.country)">
                  <div class="ellipsis header-title" :title="$t('country')">{{$t('country')}}</div>
                  <div class="arrow" :class="certificatesArrowDirection.country === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="certificatesArrowDirection.state = -(certificatesArrowDirection.state), sortBy('state', certificatesArrowDirection.state)">
                  <div class="ellipsis header-title" :title="$t('state')">{{$t('state')}}</div>
                  <div class="arrow" :class="certificatesArrowDirection.state === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="certificatesArrowDirection.city = -(certificatesArrowDirection.city), sortBy('city', certificatesArrowDirection.city)">
                  <div class="ellipsis header-title" :title="$t('city')">{{$t('city')}}</div>
                  <div class="arrow" :class="certificatesArrowDirection.city === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
            </tr>

          <tbody ref="tbodyBox" v-if="certificationBodiesData.length">
            <tr class=""
            :class="selectedRecords.includes(data.id)?'selected_row':index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in certificationBodiesData" :key="index">
              <td style="width: 30%;" class="ellipsis labs-data "><span  class="lab-name" :title="data.name">{{ data.name }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.services_offered">{{ data.services_offered }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.country">{{ data.country }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.state">{{ data.state }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.city">{{ data.city }}</span></td>

             </tr>
          </tbody>
        </table>
         <div v-if="certificationBodiesData.length === 0">
              <p class="no-records-found">{{$t('noRecordsFound')}}</p>
            </div>
      </div>
      <div class="evidences" v-if="activeTab=='Labs'">
        <table class="table table-responsive registration-data" id="servicesDataList">

            <tr style="background-color: #E6E6E6; !important;">
                <!-- <th class="" style="width:60px">    <div class="checkbox cust_checkbox">
                          <input
                            type="checkbox"
                            class="form-control"
                            v-model="isSelectAll"
                             @change="selectRecords"

                          />
                          <label></label>
                 </div></th> -->
              <th style="width: 25%;">
                <div class="tableHeader cursor-pointer pl-12" @click="arrowDirection.labName = -(arrowDirection.labName), sortBy('labName', arrowDirection.labName)">
                  <div class="ellipsis header-title" :title="$t('nameOfLab')">{{$t('nameOfLab')}}</div>
                  <div class="arrow" :class="arrowDirection.labName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: 25%;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.activityName = -(arrowDirection.activityName), sortBy('activityName', arrowDirection.activityName)">
                  <div class="ellipsis header-title" :title="$t('activityArea')">{{$t('activityArea')}}</div>
                  <div class="arrow" :class="arrowDirection.activityName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                 <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.phone = -(arrowDirection.phone), sortBy('phone', arrowDirection.phone)">
                  <div class="ellipsis header-title" :title="$t('phoneLabel')">{{$t('phoneLabel')}}</div>
                  <div class="arrow" :class="arrowDirection.phone === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.email = -(arrowDirection.email), sortBy('email', arrowDirection.email)">
                  <div class="ellipsis header-title" :title="$t('email')">{{$t('email')}}</div>
                  <div class="arrow" :class="arrowDirection.email === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.link = -(arrowDirection.link), sortBy('link', arrowDirection.link)">
                  <div class="ellipsis header-title" :title="$t('link')">{{$t('link')}}</div>
                  <div class="arrow" :class="arrowDirection.link === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>

            </tr>

          <tbody ref="tbodyBox" v-if="LabsData.length">
            <tr
            :class="index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in LabsData" :key="index">
              <!-- <td style="width:60px" class="checkbox-file"> <div class="checkbox cust_checkbox">
                          <input
                            type="checkbox"
                            class="form-control"
                            :value="data.testId"
                            v-model="selectedRecords"
                            @change="selectAllRecords"
                          />
                          <label></label>
                 </div></td> -->
              <td style="width: 25%;" class="ellipsis labs-data"><span class="lab-name" :title="data.labName">{{ data.labName }}</span></td>
              <td style="width: 25%;" class="ellipsis regulation-data"><span :title="data.activityName">{{ data.activityName }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.phone">{{ data.phone }}</span></td>
               <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.email">{{ data.email }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><a  class="lab-name blue" :href="data.link" target="_blank" :title="data.link">{{ data.link }}</a></td>

             </tr>
          </tbody>
        </table>
         <div v-if="LabsData.length === 0">
              <p class="no-records-found">{{$t('noRecordsFound')}}</p>
            </div>
      </div>
    </div>

    <loader :loadingStatus="loaderStatus"></loader>
    <!-- <contact-details ref="contactDetails" :selectedRecords="selectedRecords"></contact-details> -->

    </div>
</div>
</template>
<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/ULSearchBox.vue';
// import contactDetails from './contactDetails.vue';
import {
  getLabsData, getFilteredData,
} from '../../apis/representationResources';

export default {
  components: {
    SearchBox,
    Loader,
    EventBus,
    // contactDetails,
  },
  data() {
    return {
      activeTab: 'Labs',
      searchValue: '',
      certificationBodiesData: [],
      arrowDirection: {
        labName: 1,
        activityName: 1,
        phone: 1,
        email: 1,
        link: 1,
      },
      certificatesArrowDirection: {
        name: 1,
        services_offered: 1,
        country: 1,
        state: 1,
        city: 1
      },
      searchCount: 0,
      filteredRegulationData: [],
      loaderStatus: true,
      isRegistrationCheckComplete: '',
      isExitInMarketMandatoryFound: '',
      isPreviouslySearched: false,
      fileUpload: false,
      LabsData: [],
      selectedEvidence: '',
      isSelectAll: false,
      selectedRecords: [],
      readinessLoader: false,
      disable_readiness_button: false,
      OcpCertificationUpload: false,
      search_text: '',
      isFilteredApplied: false,
      filteredData: [],
    };
  },
  methods: {
    async showDetails() {
      $('#contactDetails').modal('show');
      this.$refs.contactDetails.contactsId = this.selectedRecords.toString();
      this.$refs.contactDetails.getContacts();
      this.selectedRecords = [];
      this.isSelectAll = false;
    },
    selectAllRecords() {
      // const data = this.activeTab === 'certification' ? this.certificationBodiesData : this.LabsData;
      this.isSelectAll = this.selectedRecords.length === this.LabsData.length;
    },

    selectRecords(type) {
      if (type === 'deselect') { this.isSelectAll = false; }
      if (this.isSelectAll) {
        const data = this.LabsData;
        this.selectedRecords = data.map((regulation) => regulation.testId);
      } else this.selectedRecords = [];
    },
    showTable(type) {
      this.activeTab = type;
      this.isSelectAll = false;
      this.selectedRecords = [];
      this.searchValue = '';
      // eslint-disable-next-line no-unused-expressions
      this.arrowDirection = {
        labName: 1,
        activityName: 1,
        phone: 1,
        email: 1,
        link: 1,
      };
      this.certificatesArrowDirection = {
        name: 1,
        services_offered: 1,
        country: 1,
        state: 1,
        city: 1
      };
      this.isFilteredApplied = false;
      this.getLabsInfo(type);
    },
    async getLabsInfo(type) {
      // eslint-disable-next-line no-multi-assign
      this.LabsData = this.certificationBodiesData = [];
      this.loaderStatus = true;
      let response = [];
      if (!this.isFilteredApplied) {
        response = type === 'Labs' ? await getLabsData(this.searchValue) : await getFilteredData(1, 50, 'Cab', this.searchValue);
      } else {
        response = this.filteredData;
      }
      if (response.length !== 0) {
        if (type === 'Labs') this.LabsData = response;
        else this.certificationBodiesData = response;
      }
      this.loaderStatus = false;
      this.filteredRegulationData = this.activeTab === 'certification' ? this.certificationBodiesData : this.LabsData;
      this.searchCount = this.activeTab === 'certification' ? this.certificationBodiesData.length : this.LabsData.length;
    },
    sortBy(type, direction) {
      if (type === 'description') return;
      const tableData = this.activeTab === 'certification' ? this.certificationBodiesData : this.LabsData;
      if (direction === 1) tableData.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        tableData.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
    async filterServiceProvidersList() {
      if (this.searchValue) {
        this.filterServiceProviders();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterServiceProviders();
        this.isPreviouslySearched = false;
      }
    },
    async filterServiceProviders() {
      const searchStr = this.searchValue.trim();
      if (this.activeTab === 'certification') this.certificationBodiesData = [];
      else this.LabsData = [];
      if (!searchStr.length) {
        await this.getLabsInfo(this.activeTab);
        return;
      }
      await this.getLabsInfo(this.activeTab);
      // this.searchCount = this.activeTab === 'certification' ? this.certificationBodiesData.length : this.LabsData.length;
    },
    searchString(searchValue, regulationsData) {
      if ((regulationsData.labName.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.testName.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.activityName.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    },
  },
  async created() {
    EventBus.$on('appliedFilteredData', async (data) => {
      this.isFilteredApplied = true;
      this.filteredData = data;
      await this.getLabsInfo('Labs');
    });
    EventBus.$on('clear-applied-filter', async () => {
      this.isFilteredApplied = false;
      await this.getLabsInfo('Labs');
    });
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    await this.getLabsInfo('Labs');
  },
  beforeDestroy() {
    EventBus.$off('updateLanguage');
  },

};
</script>
<style scoped>
.pl-12 {
  padding-left:12px !important;
}
.labs-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 12px !important;
}
.lab-name{
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;

}

.blue {
  color: #00518A !important;
}
.selected_row {
  background: #ECF5FC;
}
.checkbox {
    position: relative;
}

input[type="checkbox"] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    width: 18px !important;
    height: 18px !important;
    left: 0;
    top: 0;
    margin: 0 !important;
}

.checkbox label:before {
    content: "";
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #000000;
    display: inline-block;
    position: absolute;
    left: 0;
    top: -2px;
    border-radius: 3px;
}
.checkbox-file {
/*
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E; */
  padding: 14px 0px 0px 0px !important;

}

.checkbox.cust_checkbox input[type="checkbox"]:disabled+label:before {
    /* border: 1px solid #828282; */
    /* opacity: 0.5; */
}

.checkbox input[type="checkbox"]:checked+label:before {
    background-color: #00518A;
    background-image: url(/static/images/icons/checkbox.svg);
    background-size: 13px 15px;
    background-repeat: no-repeat;
    background-position-x: center;
    border: none;
}
/* .tbody.checkbox label{
  top: 7px !important;
} */
.checkbox label {
    cursor: auto;
    top: 5px;
    position: relative;
}

.cust_checkbox {
    /* margin: 0px; */
    margin: 0px 13px 0px 15px;
    display: inline-block;
}
.active_progress_bar {
  border-bottom:2px solid #00518A;
}
.test::after{
  position: absolute;
    content: '';
    height: 3px;
    width: 100%;
    border-bottom: 8px solid #4c9e45;
    background: none;
    left: 3px;
    bottom: 0;
}
.active-text {
  color:#000001;
}
.in-active-text {
  color:#3E3E3E;
}
.upload-file {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518A !important;
  padding-left: 4px;

}
.readiness_button,
.readiness_button:hover {
  background-color:none;
  border-radius: 3px;
  /* border: 1px solid #000001; */
  min-height: 34px;
  min-width: 161px;
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  padding: 6px 16px;
}
.pl-28 {
  padding-left: 28px;
}
.pb-11 {
  padding-bottom: 9px;
}
.main-tabs {
  background: #F5F5F5;
  padding:11px 0px 0px 11px;
  display: flex;
  column-gap: 24px;
}
.services-header {
  padding:24px 0px 0px 24px
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  /* padding-bottom: 4px; */
  padding:5px 8px 0px 0px;
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.pb-22 {
  padding-bottom: 22px;
}
.pb-14 {
  padding-bottom: 14px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 0px !important;
}
.regulation-message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.services-main{
    background-color: #E5E5E5 !important;
    height: calc(100vh - 50px) !important;

}
.services_check {
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  color: #3E3E3E;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 0px;
  column-gap: 7px
  /* justify-content: center; */
}
.servicesBackground {
  background-color: #ebebeb;
}
#servicesDataList {
  /* margin-bottom:62px; */
}
#servicesDataList th .arrow {
  opacity: 1;
}
.pr-4 {
    padding-right:4px;
}

#servicesDataList thead,

#servicesDataList tbody,

#servicesDataList tr:not(#servicesDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}

.evidences, .regulations {
  /* overflow-x: scroll; */
  margin-bottom: 11px;
}

.pl-24 {
  padding-left: 24px;
  /* min-height: 800px; */
}
/* @media (min-width: 2278px){
  .pl-24 {
    height: 100vh;
  }
} */
</style>
